import {
  listFiles,
  uploadFile,
  uploadFolder,
  removeFile,
} from "../api/storage";
import { getDownloadUrl } from "../utils/storage";
const storage = {
  state: {
    prefix: "",
    folders: [],
    files: [],
    storageHistory: [],
    list: [],
  },
  reducers: {
    setState(state, payload) {
      this.state = { ...state, ...payload };
      return { ...this.state };
    },
    pushHistory(state, payload) {
      state.storageHistory.push(payload);
      return { ...state };
    },
    popHistory(state, payload) {
      state.storageHistory.pop();
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    async listFiles(payload, rootState) {
      const response = await listFiles();
      if (response.code !== 1) {
        return response;
      }
      let { folders, files } = response.data;

      folders = folders.map((item, index) => {
        return {
          code: index,
          key: item,
          url: "",
          download: "",
          thumbnail: "",
          size: null,
          createdAt: null,
          name: item,
          path: "",
        };
      });
      files = files.map((item, index) => {
        return {
          code: index,
          key: item.key,
          url: item.url,
          download: getDownloadUrl(item.url),
          thumbnail: item.url,
          size: item.size,
          createdAt: item.createdAt || null,
          name: item.key,
          path: item.key,
        };
      });
      this.setState({
        list: [...folders, ...files],
      });
      return response;
    },
    uploadFile(payload, rootState) {
      const { file, serviceCode, prefix } = payload;
      return uploadFile({ file, serviceCode, prefix });
    },
    uploadFolder(payload, rootState) {
      const { serviceCode, prefix } = payload;
      return uploadFolder({ serviceCode, prefix });
    },
    removeFile(payload, rootState) {
      return removeFile(payload);
    },
  }),
};

export default storage;
